import React from 'react';
import { useProfile } from '../../context/contextProfile';
import { useThemeMode } from '../../context/contextTheme';

const SidebarLogo = ({ height, width }) => {
  const { theme } = useThemeMode();
  const { sidebarExtended, profilePicUrl, username, name } = useProfile();

  return (
    <div
      className="sidebar-logo-section d-flex flex-column justify-content-start align-items-center text-center"
      style={{
        width: '100%',
        paddingTop: sidebarExtended ? '15px' : '10px',
        paddingBottom: sidebarExtended ? '15px' : '5px',
        transition: 'all 0.4s ease',
      }}
    >
      {/* 🔹 Profile Picture */}
      <img
        src={profilePicUrl}
        alt="User"
        width={sidebarExtended ? width : width * 0.55}
        height={sidebarExtended ? height : height * 0.55}
        className="rounded-circle"
        style={{
          border: `3px solid ${theme.border}`,
          transition: 'all 0.4s ease',
          objectFit: 'cover',
          transform: sidebarExtended ? 'scale(1)' : 'scale(0.9)',
        }}
      />

      {/* 🔹 Name + Username */}
      <div
        className="sidebar-user-info"
        style={{
          opacity: sidebarExtended ? 1 : 0,
          transform: sidebarExtended ? 'translateY(15px)' : 'translateY(130px)',
          maxHeight: sidebarExtended ? '100px' : '0px',
          overflow: 'hidden',
          transition: 'all 0.5s ease',
        }}
      >
        <div
          className="fw-semibold text-truncate mt-3"
          style={{
            maxWidth: 160,
            color: theme.textColor,
            fontSize: '0.95rem',
          }}
        >
          {name}
        </div>
        <div
          className="small"
          style={{
            color: theme.textMuted,
            fontSize: '0.85rem',
          }}
        >
          @{username}
        </div>
      </div>
    </div>
  );
};

export default SidebarLogo;
